import { h } from 'preact';
import * as BaseComp from 'components/bolt/landscapeOverlay/landscapeOverlay.js';
import Store from 'store/store';
// import s from 'components/bolt/landscapeOverlay/landscapeOverlay.sss';

export default class LandscapeOverlay extends BaseComp.default {

	render() {
		const activePage = Store.get()?.activePage;
		if (activePage === 'map') return;
		return super.render();
	}

}
